import { IconBolt, IconCheckSquare, IconSitemap } from '@maia/icons';
import { Button, Typography } from '@maia/ui';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  component: Component,
});

function Component() {
  function handleLogin() {
    window.location.href = `${import.meta.env.VITE_MAIA_API_PATH}/api/auth/login`;
  }

  return (
    <div className="layout-auth">
      <div className="area-form">
        <div className="p-48">
          <img
            src="/images/logo/maia-logo.svg"
            alt="Maia logo"
            className="w-64 h-20 object-contain"
          />
        </div>
        <div className="p-48">
          <Typography
            as="h1"
            variant="display6"
            weight="semibold"
            className="text-primaryMain"
          >
            Inloggen Broker Studio
          </Typography>
          <div className="flex flex-col gap-y-32 mt-32">
            <Button
              intent="primary"
              size="large"
              className="text-center w-fit"
              onPress={handleLogin}
            >
              Login
            </Button>
          </div>
        </div>
      </div>
      <div className="area-info flex flex-col px-48 pt-48">
        <div className="bg-primary50 flex-1 rounded-t-24 rounded-br-24 w-full h-full p-64 relative">
          <img
            src="/images/illustrations/floating-in-space.svg"
            alt="Maia logo"
            className="absolute w-[405px] md:hidden lg:block h-[330px] z-10 right-0 translate-x-48 -translate-y-48 top-0"
          />
          <Typography
            variant="display2"
            className="text-primaryMain block"
            weight="semibold"
          >
            De toekomst van
            <br />
            verzekeringen
          </Typography>
          <Typography
            variant="display4"
            className="text-primaryMain block mt-12"
            weight="regular"
          >
            Overzichtelijker, makkelijker én leuker
          </Typography>

          <ul className="space-y-32 mt-48">
            {[
              {
                icon: <IconBolt className="fill-info300 min-w-24 w-24 h-24" />,
                title: 'Snel toegang tot klant- en polisgegevens.',
              },
              {
                icon: (
                  <IconSitemap className="fill-info300 min-w-24 w-24 h-24" />
                ),
                title: 'Slimme datakoppelingen voor direct inzicht.',
              },
              {
                icon: (
                  <IconCheckSquare className="fill-info300 min-w-24 w-24 h-24" />
                ),
                title: 'Efficiënt taakbeheer, alles op één plek.',
              },
            ].map(({ icon, title }) => (
              <li key={`usp-${title}`}>
                <div className="bg-grayscale0 rounded-12 p-24 flex flex-row items-center space-x-12">
                  {icon}
                  <Typography
                    variant="display6"
                    className="text-primaryMain"
                    weight="medium"
                  >
                    {title}
                  </Typography>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="flex flex-row justify-between items-center">
          <div className="bg-primary50 h-full w-full rounded-b-24" />
          <div className="bg-primary50">
            <div className="px-48 py-32 bg-grayscale0 rounded-tl-24">
              <img
                src="/images/logo/maia-logo.svg"
                alt="Maia logo"
                className="min-w-[74px] h-24 object-contain"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="area-footer flex flex-row items-center justify-between px-48 py-32">
        <Typography
          variant="body-xs"
          className="text-grayscale400 cursor-pointer"
          weight="regular"
        >
          Privacy policy
        </Typography>
        <Typography
          variant="body-xs"
          className="text-grayscale400"
          weight="regular"
        >
          Lukt het niet om in te loggen?{' '}
          <Typography
            as="span"
            variant="body-xs"
            className="text-info300 underline cursor-pointer"
          >
            Klik hier
          </Typography>{' '}
          voor ondersteuning.
        </Typography>
      </div>
    </div>
  );
}
